import React from "react";
import Header from "../Header";
import Footer from "../Footer";

const Blog = ({ title, sections }) => {
  return (
    <>
      <Header />
      <div className="max-w-7xl mx-auto p-6 space-y-8 mt-20">
        <h1 className="text-4xl font-bold text-center text-[#278083]">
          {title}
        </h1>
        {sections.map((section, idx) => (
          <div key={idx} className="bg-white">
            {section.title && (
              <h2 className="text-2xl font-semibold text-[#278083]">
                {section.title}
              </h2>
            )}
            {section.subtitle && (
              <h3 className="text-lg font-medium text-black">
                {section.subtitle}
              </h3>
            )}
            <p className="text-gray-700 mt-2 mb-4">{section.content}</p>
            {section.image && (
              <img
                src={section.image}
                alt={section.title}
                className="w-full h-[500px] object-cover object-center mb-4"
              />
            )}
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Blog;
